<template>
    <div class="h-100">
        <div class="wt-leader-detail-right-table wt-scroll my-3" v-if="Object.keys(leaderTradeHistory).length && leaderTradeHistory.content && leaderTradeHistory.content.length ">
            <div class="table-responsive wt-scroll border-0 ">
                <table class="table border-0 mw-100" >
                    <thead>
                        <tr>
                            <th class="custom-width">{{$t('investment')}}</th>
                            <th class="custom-width">{{$t('open_date_time')}}</th>
                            <th class="custom-width">{{$t('type')}}</th>
                            <th class="custom-width">{{$t('lots')}}</th>
                            <th class="custom-width">{{$t('open')}}</th>
                            <th class="custom-width">{{$t('close_date_time')}}</th>
                            <th class="custom-width">{{$t('close_price')}} </th>
                            <th class="custom-width">{{$t('high')}}</th>
                            <th class="custom-width">{{$t('low')}}</th>
                            <th class="custom-width">{{$t('roll')}}</th>
                            <th class="custom-width">{{$t('profit_slash_loss')}}</th>
                            <th class="custom-width">{{$t('total')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        
                        <tr v-for="item in leaderTradeHistory.content" :key="item.id">
                            <td>
                                <img width="25" height="25" :src="'https://finvasiaexpos.s3.eu-west-2.amazonaws.com/tradingsymbol/' + getCurrency(item.currency) + '.svg'"
                                    :alt="item.currency" /> <span>{{ item.currency || '' }} </span>
                            </td>
                            <td>
                                <span>{{ convertEdtTimeToLocalTimeZone(item.dateOpen, 'DD-MM-YYYY') }}</span>
                                <span> | </span>
                                <span>{{ convertEdtTimeToLocalTimeZone(item.dateOpen, 'HH:mm:ss') }}</span>
                            </td>
                            <td>
                                <a href="#" class="btn f-12 py-0"
                                    :class="(item.tradeType == 'BUY') ? 'greenBG' : 'redBG'">{{ item.tradeType }}</a>
                                <!-- <a href="" class="btn f-12 redBG py-0">Sell</a> -->
                            </td>
                            <td>{{ item.lots }}</td>
                            <td>{{ item.priceOpen }}</td>
                            <td>
                                <span>{{ convertEdtTimeToLocalTimeZone(item.dateClosed, 'DD-MM-YYYY') }}</span>
                                <span> | </span>
                                <span>{{ convertEdtTimeToLocalTimeZone(item.dateClosed, 'HH:mm:ss') }}</span>
                            </td>
                            <td>{{ item.priceClosed || '' }}</td>
                            <td>{{ item.maxProfit || 0 }}</td>
                            <td>{{ item.worstDrawdown || 0 }}</td>
                            <td>{{ item.interest || 0 }}</td>
                            <td>
                                <span class="d-block">{{ (parseFloat(item.netPnl) > 0) ? '+' : '-' }}${{
                            parseFloat(Math.abs(item.netPnl)).toFixed(2) }}</span>
                                <span class="d-block gray-color">{{(parseFloat(item.pips) > 0) ? '+' : ''}}
                                    {{ parseFloat(item.pips).toFixed(2) }} <span>{{$t('pips')}}</span></span>
                            </td>
                            <td>
                                <span class="d-block">{{ (parseFloat(item.totalAccumulatedPnl) > 0) ? '+' :
                            '-' }}${{ parseFloat(item.totalAccumulatedPnl).toFixed(2) }}</span>
                                <span class="d-block gray-color">{{ item.totalAccumulatedPips.toLocaleString('en')}}
                                    <span>pips</span></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="noDataPic h-100 w-100 d-flex align-items-center justify-content-center" v-else>
            <img src="../../../../../static/website/images/no-data.svg" alt="" />
            
        </div>
        <pagination class="justify-content-end" :totalRecords="leaderTradeHistory.totalElements" :limit="pageLimit" :pageNo="page" :showRecords="false" v-if="Object.keys(leaderTradeHistory).length && (leaderTradeHistory.totalElements > pageLimit) "></pagination>
    </div>
</template>
<script>
import { commonAllmixins } from "@/plugins/commonAll";
import moment from 'moment-timezone';
export default {
    mixins: [commonAllmixins],
    data() {
        return {
            popup: '',
            page: 1,
            pageLimit: 10,
            pageLoader: false
        }
    },
    methods: {
        convertEdtTimeToLocalTimeZone(edtTime, format = 'DD-MM-YYYY, h:mm:ss') {
            if (edtTime) {
                // Parse the input time as an EDT time
                const momentEDT = moment.tz(edtTime, "America/New_York");
                // Convert to the system's local time zone
                const localTime = momentEDT.clone().tz(moment.tz.guess());
                return localTime.format(format);
            }
        },
        clearFun() {
            this.popup = ''
        },
        listing() {
            this._runGetLeaderTradeHistory({ 'globalParams': {}, 'localParams': { "provider_id": this.divide9(this.$route.query.id), 'page': this.page - 1, 'pageLimit': this.pageLimit, "parameter": this } })
        },
        getDateTime(date) {
            if (date) {
                let dateOpen = moment(date).format('DD/MM/YYYY')
                let timeOpen = moment(date).format('HH:MM a')
                return (dateOpen + ' | ' + timeOpen)
            }
        },
        convertFormat(time, format = 'DD-MM-YYYY hh:mm:ss') {
            if (!time) return 'N/A'
            return moment(time).format(format)

        },
        getCurrency(currency) {
            if (currency) {
                let curr = currency.includes('/');
                if (curr) {
                    return currency.split('/').join('')
                } else {
                    return currency
                }
            }
        }
    },
    mounted() {
        this.listing()
    }
}
</script>


// WEBPACK FOOTER //
// src/components/website/copy-trade/leader-detail/table.vue